import { Templates } from '../../compile';
import { DateTimePickerOptions } from '../../interfaces/options';

export const DefaultDateTimePickerOptions: DateTimePickerOptions = {
	widget: {
		widget: Templates.widgets_dateTimePicker
	},
	calendar: {
		firstDay: 1,
		autoclose: false,
		showTime: true
	}
};
